"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthHeader = exports.AuthStatus = exports.NullabilityEnum = exports.DateFormat = exports.PeriodTypeEnum = exports.DeviceIdTypeEnum = exports.AudienceConditionTagEnum = exports.EventActionEnum = exports.MailServiceMessageTypeEnum = exports.BooleanStringEnum = exports.DBPlatformEnum = exports.OperatorEnum = exports.PGSQLActionTypeEnum = exports.QueueStatusEnum = exports.ValidatorOptionsEnum = exports.RTLLanguageEnum = exports.PeriodEnum = exports.OrderByEnum = exports.ComparisonEnum = exports.SegmentEnum = exports.getIntervalName = exports.QueryLevelEnum = exports.IntervalEnum = exports.PlatformEnum = exports.CERTPATH = void 0;
// Constant representing the path to the directory where application certificates are stored
exports.CERTPATH = "/certs/appcertificates/";
var PlatformEnum;
(function (PlatformEnum) {
    PlatformEnum["ALL"] = "all";
    PlatformEnum["ANDROID"] = "Android";
    PlatformEnum["IOS"] = "iOS";
    PlatformEnum["WEB"] = "Web";
    PlatformEnum["UNKNOWN"] = "Unknown";
})(PlatformEnum = exports.PlatformEnum || (exports.PlatformEnum = {}));
var IntervalEnum;
(function (IntervalEnum) {
    IntervalEnum["DAYS"] = "d";
    IntervalEnum["HOURS"] = "h";
    IntervalEnum["MINUTES"] = "m";
    IntervalEnum["SECONDS"] = "s";
    IntervalEnum["DAYS_OR_MORE"] = "dm";
    IntervalEnum["DAYS_OR_LESS"] = "dl";
})(IntervalEnum = exports.IntervalEnum || (exports.IntervalEnum = {}));
var QueryLevelEnum;
(function (QueryLevelEnum) {
    QueryLevelEnum["OUTER"] = "outer";
    QueryLevelEnum["INNER"] = "inner";
})(QueryLevelEnum = exports.QueryLevelEnum || (exports.QueryLevelEnum = {}));
const IntervalNameMap = {
    [IntervalEnum.DAYS]: "days",
    [IntervalEnum.HOURS]: "hours",
    [IntervalEnum.MINUTES]: "minutes",
    [IntervalEnum.SECONDS]: "seconds",
    [IntervalEnum.DAYS_OR_MORE]: "days or more",
    [IntervalEnum.DAYS_OR_LESS]: "days or less",
};
function getIntervalName(value) {
    return IntervalNameMap[value];
}
exports.getIntervalName = getIntervalName;
var SegmentEnum;
(function (SegmentEnum) {
    SegmentEnum["FUNCSEGMENT"] = "funcsegment";
    SegmentEnum["AUDSEGMENT"] = "audsegment";
})(SegmentEnum = exports.SegmentEnum || (exports.SegmentEnum = {}));
var ComparisonEnum;
(function (ComparisonEnum) {
    ComparisonEnum["FROM"] = "from";
    ComparisonEnum["BEFORE"] = "before";
})(ComparisonEnum = exports.ComparisonEnum || (exports.ComparisonEnum = {}));
var OrderByEnum;
(function (OrderByEnum) {
    OrderByEnum["ASC"] = "ASC";
    OrderByEnum["DESC"] = "DESC";
})(OrderByEnum = exports.OrderByEnum || (exports.OrderByEnum = {}));
var PeriodEnum;
(function (PeriodEnum) {
    PeriodEnum["YESTERDAY"] = "Yesterday";
    PeriodEnum["TODAY"] = "Today";
    PeriodEnum["TOMORROW"] = "Tomorrow";
    PeriodEnum["CURRENT_MONTH"] = "CURRENT_MONTH";
    PeriodEnum["CURRENT_DAY"] = "CURRENT_DAY";
    PeriodEnum["CURRENT_DATE"] = "CURRENT_DATE";
    PeriodEnum["THIS_WEEK"] = "This Week";
    PeriodEnum["LAST_WEEK"] = "Last Week";
    PeriodEnum["THIS_MONTH"] = "This Month";
    PeriodEnum["LAST_MONTH"] = "Last Month";
    PeriodEnum["CUSTOM"] = "Custom";
})(PeriodEnum = exports.PeriodEnum || (exports.PeriodEnum = {}));
var RTLLanguageEnum;
(function (RTLLanguageEnum) {
    RTLLanguageEnum["ARABIC"] = "Arabic";
    RTLLanguageEnum["URDU"] = "Urdu";
})(RTLLanguageEnum = exports.RTLLanguageEnum || (exports.RTLLanguageEnum = {}));
var ValidatorOptionsEnum;
(function (ValidatorOptionsEnum) {
    ValidatorOptionsEnum["REGEX"] = "regex";
    ValidatorOptionsEnum["CUSTOM"] = "custom";
    ValidatorOptionsEnum["FILE"] = "file";
})(ValidatorOptionsEnum = exports.ValidatorOptionsEnum || (exports.ValidatorOptionsEnum = {}));
var QueueStatusEnum;
(function (QueueStatusEnum) {
    QueueStatusEnum["INITIATED"] = "initiated";
    QueueStatusEnum["FAILED"] = "failed";
    QueueStatusEnum["PROCESSED"] = "processed";
})(QueueStatusEnum = exports.QueueStatusEnum || (exports.QueueStatusEnum = {}));
var PGSQLActionTypeEnum;
(function (PGSQLActionTypeEnum) {
    PGSQLActionTypeEnum["SET_READ_ONLY"] = "SET TRANSACTION READ ONLY";
})(PGSQLActionTypeEnum = exports.PGSQLActionTypeEnum || (exports.PGSQLActionTypeEnum = {}));
var OperatorEnum;
(function (OperatorEnum) {
    OperatorEnum["AND"] = "AND";
    OperatorEnum["OR"] = "OR";
})(OperatorEnum = exports.OperatorEnum || (exports.OperatorEnum = {}));
var DBPlatformEnum;
(function (DBPlatformEnum) {
    DBPlatformEnum["ANDROID"] = "Android";
    DBPlatformEnum["IOS"] = "IOS";
    DBPlatformEnum["WEB"] = "Web";
})(DBPlatformEnum = exports.DBPlatformEnum || (exports.DBPlatformEnum = {}));
var BooleanStringEnum;
(function (BooleanStringEnum) {
    BooleanStringEnum["TRUE"] = "true";
    BooleanStringEnum["FALSE"] = "false";
})(BooleanStringEnum = exports.BooleanStringEnum || (exports.BooleanStringEnum = {}));
var MailServiceMessageTypeEnum;
(function (MailServiceMessageTypeEnum) {
    MailServiceMessageTypeEnum["PASSWORD_RESET_INFO"] = "passwordResetInfo";
    MailServiceMessageTypeEnum["OTP_VERIFICATION"] = "otpVerification";
})(MailServiceMessageTypeEnum = exports.MailServiceMessageTypeEnum || (exports.MailServiceMessageTypeEnum = {}));
var EventActionEnum;
(function (EventActionEnum) {
    EventActionEnum["DID_PERFORM"] = "dp";
    EventActionEnum["DID_NOT_PERFORM"] = "dnp";
})(EventActionEnum = exports.EventActionEnum || (exports.EventActionEnum = {}));
var AudienceConditionTagEnum;
(function (AudienceConditionTagEnum) {
    AudienceConditionTagEnum["LIVE_EVENT"] = "le";
    AudienceConditionTagEnum["PAST_EVENT"] = "pe";
    AudienceConditionTagEnum["TRAIT"] = "trait";
    AudienceConditionTagEnum["JOURNEY_ACTION"] = "ja";
})(AudienceConditionTagEnum = exports.AudienceConditionTagEnum || (exports.AudienceConditionTagEnum = {}));
var DeviceIdTypeEnum;
(function (DeviceIdTypeEnum) {
    DeviceIdTypeEnum["CUSTOM_USER_ID"] = "_custom_userid";
    DeviceIdTypeEnum["DID"] = "did";
})(DeviceIdTypeEnum = exports.DeviceIdTypeEnum || (exports.DeviceIdTypeEnum = {}));
var PeriodTypeEnum;
(function (PeriodTypeEnum) {
    PeriodTypeEnum["HOURS"] = "hours";
    PeriodTypeEnum["MINUTES"] = "minutes";
    PeriodTypeEnum["SECONDS"] = "seconds";
})(PeriodTypeEnum = exports.PeriodTypeEnum || (exports.PeriodTypeEnum = {}));
var DateFormat;
(function (DateFormat) {
    DateFormat["STANDARD_DATE_TIME"] = "YYYY-MM-DD HH:mm:ss";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
var NullabilityEnum;
(function (NullabilityEnum) {
    NullabilityEnum["NULL"] = "NULL";
    NullabilityEnum["NOT_NULL"] = "NOT NULL";
})(NullabilityEnum = exports.NullabilityEnum || (exports.NullabilityEnum = {}));
var AuthStatus;
(function (AuthStatus) {
    AuthStatus["ENABLE"] = "enable";
    AuthStatus["DISABLE"] = "disable";
})(AuthStatus = exports.AuthStatus || (exports.AuthStatus = {}));
var AuthHeader;
(function (AuthHeader) {
    AuthHeader["AUTH_SCOPE"] = "x-auth-scope";
})(AuthHeader = exports.AuthHeader || (exports.AuthHeader = {}));
